<template>
  <div class="fd-wrapper">
    <div id="autoScroll1" class="fd-headWrapper">
      <div class="fd-titleWrapper">
        <button type="button" class="fd-button" @click="backPage">
          <BackArrowIcon />
        </button>
        <div class="fd-folderName">
          <p class="fd-folderTitle">Хавтас:</p>
          {{ folderName }}
        </div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div style="
                display: flex;
                align-items: center;
                width: 19px;
                height: 19px;
                margin: 0 8px;
              " v-on="on" v-bind="attrs">
              <InfoIcon />
            </div>
          </template>
          <span>Хавтас үүсгэсэн огноо: {{ getFormatDate }}</span>
        </v-tooltip>
      </div>
      <v-btn class="fd-createAudiosButton" @click="clearState">
        <div style="margin-right: 10px">
          <FileIcon />
        </div>
        Шинэ файл оруулах
      </v-btn>
    </div>
    <div id="autoScroll" v-if="infoLoading != true">
      <FileUpload v-if="focusedFileIndex == null" ref="newFileSynthesize" :folderId="folderId"
        :addFileInfo="addFileInfo" :clientKey="clientKey" :clearState="clearState" />
      <FileSynthAndDetails v-else :fileInfo="{
        fileId: audios[focusedFileIndex].id,
        fileName: audios[focusedFileIndex].name,
        status: audios[focusedFileIndex].status,
        index: focusedFileIndex,
        synthesized: audios[focusedFileIndex].total_synthesized,
        total: audios[focusedFileIndex].total,
        pagesInfo: audios[focusedFileIndex].projects,
        defaultPageInfo: defaultPageInfo,
      }" :deleteFile="deleteFile" :getFileInfo="getFileInfo" />
    </div>
    <div v-else class="fd-infoLoadingWrapper">
      <v-progress-circular :size="40" :width="3" color="#787ff7" indeterminate></v-progress-circular>
    </div>
    <div v-if="audiosLoading != true" class="fd-tableWrapper">
      <template v-if="audios.length != 0">
        <div class="fd-tableTitle">Файлуудын жагсаалт</div>
        <div class="fd-tableHeader">
          <div class="fd-fileName">Файлын нэр</div>
          <div class="fd-status">Төлөв</div>
          <div class="fd-duration">Бичлэгийн тоо</div>
          <div class="fd-createdDate">Үүсгэсэн огноо</div>
        </div>
        <template v-for="(item, index) in audios">
          <FileInfo :focus="
            focusedFileIndex != null &&
              audios[focusedFileIndex].id === item.id
              ? true
              : false
          " :fileId="item.id" :index="index" :name="item.name" :date="item.created_date" :duration="item.total"
            :total_synthesized="item.total_synthesized" :status="item.status" :total="item.total"
            :deleteAudioShowDialog="deleteAudioShowDialog" :editAudioShowDialog="editAudioShowDialog"
            :showFileInfo="getFileInfo" :key="item.id" />
        </template>
      </template>
    </div>
    <div v-else class="fd-loadingLinear">
      <v-progress-linear color="#777ff6" indeterminate reverse></v-progress-linear>
    </div>
    <v-dialog v-model="editDialog" persistent max-width="500">
      <v-card class="fd-dialogWrapper">
        <div class="fd-dialogTitleWrapper">
          <EditIcon />
          <div class="fd-dialogTitle">Аудио бичлэгийн нэр солих</div>
        </div>
        <div class="fd-dialogWarn">Аудио бичлэгийн шинэ нэрийг оруулна уу</div>
        <div class="fd-inputDialogWrapper">
          <input type="text" autocomplete="off" placeholder="нэр оруулах..." name="editAudio" id="editFileName"
            v-model="editName" />
          <span v-if="inputError == true" class="fd-errorInput">{{
              inputErrorText
          }}</span>
        </div>
        <div class="fd-dialogActionWrapper">
          <v-btn color="darken-1" class="fd-closeBtn" text @click="closeDialog">хаах</v-btn>
          <v-btn class="fd-changeBtn" text :loading="this.dialogLoading" @click="updateFileAudioName">солих</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeDialog" persistent max-width="380">
      <v-card class="fd-dialogWrapper">
        <div class="fd-dialogRemoveTitleWrapper">
          <DeleteIcon />
          <div class="fd-dialogRemoveTitle">
            {{ $t("fileFolderDetails.delete") }}
          </div>
        </div>
        <div class="fd-dialogRemoveQuestion">
          {{ $t("fileFolderDetails.sure") }}
        </div>
        <div class="fd-dialogActionWrapper">
          <v-btn color="darken-1" class="fd-closeBtn" text @click="closeDialog">{{ $t("fileFolderDetails.close") }}
          </v-btn>
          <v-btn class="fd-removeBtn" text @click="deleteAudio" :loading="dialogLoading">{{ $t("fileFolderDetails.yes")
          }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import FileUpload from "../components/FileUpload";
import FileSynthAndDetails from "../components/FileSynthAndDetails";
import FileInfo from "../components/FileInfo";
import { format } from "date-fns";
// icon
import BackArrowIcon from "../components/icons/BackArrowIcon";
import FileIcon from "../components/icons/FileIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import EditIcon from "../components/icons/EditIcon";
import InfoIcon from "../components/icons/InfoIcon";
import { mapState, mapActions } from "vuex";
import { groupRequest } from "../project_pb";
export default {
  name: "fileFolderDetails",
  components: {
    FileUpload,
    FileSynthAndDetails,
    BackArrowIcon,
    FileIcon,
    FileInfo,
    DeleteIcon,
    EditIcon,
    InfoIcon,
  },
  data: () => ({
    folderName: "",
    folderId: null,
    folderCreatedDate: null,
    token: null,
    audios: [],
    oldAudios: [],
    partAudios: [],
    count: 0,
    page: 1,
    pageCount: 0,
    itemsPerPage: 1000,
    focusedFileIndex: null,
    infoLoading: false,
    convertLoading: false,
    audiosLoading: false,
    dialogLoading: false,
    balance: null,
    editName: "",
    removeDialog: false,
    editDialog: false,
    inputError: false,
    inputErrorText: "",
    editAudioId: null,
    editAudioIndex: null,
    selectedFile: null,
    video: "https://www.youtube.com/watch?v=LY0lLcz3Qis&t=2s",
    defaultPageInfo: null,
  }),
  created() {
    this.folderId = Number(this.$route.params.folderId);
  },
  mounted() {
    this.getAudiosOfFolder();
  },
  watch: {
    editName: function () {
      this.inputValidate();
    },
    fileInfo: function () {
      this.updateList(this.fileInfo);
    },
  },
  computed: {
    ...mapState(["focusedFileId", "clientKey", "fileInfo"]),
    getToken: function () {
      return this.$cookie.get("token");
    },
    getFormatDate: function () {
      var currentDate = new Date(this.folderCreatedDate);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
    ids: function () {
      let list = [];
      for (let i = 0; i < this.audios.length; i++) {
        list.push(this.audios[i].ProjectID);
      }
      return list;
    },
  },
  methods: {
    ...mapActions([
      "showSuccessMessage",
      "showErrorMessage",
      "showWarningMessage",
      "checkError",
      "setFocusedFileId",
      "setFileInfo",
    ]),
    /*  Хөрвүүлэгдсэн байгаа бүх аудио бичлэгийн листийг харуулах функц */
    getAudiosOfFolder() {
      this.audiosLoading = true;
      const headers = {
        token: this.getToken,
      };
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/v2/group/${this.folderId}?page=${this.page}&per_page=${this.itemsPerPage}`,
          {
            headers,
          }
        )
        .then((response) => {
          this.folderName = response.data.data.name;
          this.folderCreatedDate = response.data.data.created_date;
          if (response.data.data.sub_groups != null) {
            this.audios = response.data.data.sub_groups;
          }
          this.audiosLoading = false;
        })
        .catch((error) => {
          this.audiosLoading = false;

          this.checkError(error);
        });
    },
    addSubscribeFile(fileId) {
      let params = new groupRequest();
      params.setClientKey(this.clientKey);
      params.setGroupId(fileId);
      this.client.subscribeGroup(
        params,
        {
          token: this.getToken,
        },
        (err) => {
          if (err) {
            console.log(err);
          }
        }
      );
    },
    updateList(data) {
      let currentList = this.audios;
      currentList.forEach((value, index) => {
        if (data.oldGroupId === value.id) {
          this.audios[index].total = data.total;
          this.audios[index].total_synthesized = data.totalSynthesized;
          this.audios[index].status = data.groupStatus;
          Vue.set(this.audios, index, this.audios[index]);
          return;
        }
      });
    },
    nextPage(page) {
      this.page = page;
      this.getAudioList();
    },
    backPage() {
      this.$router.go(-1);
    },

    /* Хөрвүүлэгдсэн аудиог устгах функц*/
    deleteAudio() {
      this.dialogLoading = true;
      var headers = { token: this.getToken };
      axios
        .delete(
          `${process.env.VUE_APP_BASE_URL}/v2/group/${this.editAudioId}`,
          {
            headers,
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.showSuccessMessage({
              message: "Аудио устгагдлаа",
              timeout: 3000,
            });
            if (
              this.focusedFileIndex != null &&
              this.audios[this.focusedFileIndex].id == this.editAudioId
            ) {
              this.setFocusedFileId(null);
              this.clearState();
            }
            this.audios = this.audios.filter(
              (audio) => audio.id !== this.editAudioId
            );
            this.closeDialog();
          }
        })
        .catch((error) => {
          this.dialogLoading = false;
          this.checkError(error);
        });
    },
    /* Аудионы нэрийг солихийн тулд диалог гаргах функц*/
    deleteAudioShowDialog(fileId) {
      this.editAudioId = fileId;
      this.removeDialog = true;
    },

    /**Сүүлчийн хуудас устахад файл устах функц */
    deleteFile(fileId) {
      this.editAudioId = fileId;
      this.deleteAudio();
    },

    /* Аудионы нэрийг солихийн тулд диалог гаргах функц*/
    editAudioShowDialog(fileId, index, name) {
      this.editAudioId = fileId;
      this.editName = name;
      this.editAudioIndex = index;
      this.editDialog = true;
    },

    addFileInfo(fileId, file_name) {
      const audio = {
        id: fileId,
        total: 0,
        total_synthesized: 0,
        status: "data_preparing",
        name: file_name,
        created_date: new Date().toString(),
        type: "file",
      };
      this.audios = [audio, ...this.audios];
      // this.addSubscribeFile(fileId);
    },

    updateFileAudioName() {
      if (this.inputValidate()) {
        this.dialogLoading = true;
        const headers = { token: this.getToken };
        axios
          .put(
            `${process.env.VUE_APP_BASE_URL}/v2/group/${this.editAudioId}/name`,
            this.editName,
            { headers }
          )
          .then((response) => {
            if (response.status == 200) {
              this.audios[this.editAudioIndex].name = this.editName;
              this.showSuccessMessage({
                message: "Амжилттай шинэчлэгдлээ",
                timeout: 3000,
              });
              this.closeDialog();
            }
          })
          .catch((error) => {
            this.closeDialog();
            this.checkError(error);
          });
      }
    },

    /* Хөрвүүлсэн аудионы текстийн харах,Тухайн аудио төслийн бүх мэдээллийг харуулна*/
    getFileInfo(fileId, index, pagesCount) {
      var el = document.getElementById("autoScroll1");
      el.scrollIntoView();
      event.stopPropagation();
      if (this.focusedFileIndex != index) {
        const headers = { token: this.getToken };
        this.infoLoading = true;
        this.axios
          .get(
            `${process.env.VUE_APP_BASE_URL}/v2/group/${fileId}?page=1&per_page=${pagesCount}`,
            {
              headers,
            }
          )
          .then((response) => {
            this.audios[index] = response.data.data;
            this.focusedFileIndex = index;
            this.getPageInfo(this.audios[index].projects[0].id);
          })
          .catch((error) => {
            this.checkError(error);
          });
      }
    },

    getPageInfo(pageId) {
      const headers = {
        token: this.getToken,
      };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/v2/project/${pageId}`, {
          headers,
        })
        .then((response) => {
          this.defaultPageInfo = response.data.data;
          this.setFocusedFileId(this.audios[this.focusedFileIndex].id);
          this.infoLoading = false;
        })
        .catch((error) => {
          this.checkError(error);
        });
    },
    watchVideo() {
      this.videoInsDialog = true;
    },

    /* Шинэ бичвэр оруулахад оролтын мэдээллүүдийг цэвэрлэх функц*/
    clearState() {
      this.setFocusedFileId(null);
      this.infoLoading = false;
      this.focusedFileIndex = null;
      this.$nextTick(function () {
        document.getElementById("fileInput").focus();
      });
    },

    /* Засварлах функц*/
    setSettingsAudio(settings) {
      this.config = {
        inputText: settings.text,
        voiceID: settings.voiceId,
        selectedSpeed: settings.speed,
        background: settings.background,
        pitch: settings.pitch,
      };
      this.infoLoading = false;
      this.focusedFileIndex = null;
      // this.inputValue = text;
    },
    changeDesc(percent) {
      if (percent == 100) {
        this.showSuccessMessage({
          message: "Амжилттай хөрвүүлэгдлээ",
          timeout: 3000,
        });
      } else {
        this.showSuccessMessage({
          message: "Амжилттай үүслээ. Хөрвүүлэгдэж байна!",
          timeout: 3000,
        });
      }
    },

    /* Диалог хаах функц */
    closeDialog() {
      this.inputError = false;
      this.editDialog = false;
      this.removeDialog = false;
      this.dialogLoading = false;
    },

    /* Тухайн эдитор дээр оруулсан зүйлүүдийг шалгах функц */
    inputValidate() {
      if (this.editName.length == 0) {
        this.inputErrorText = "Нэрээ оруулна уу";
        this.inputError = true;
        return false;
      } else if (this.editName.length > 50) {
        this.inputErrorText = "Нэр 50-н тэмдэгтээс бага байх ёстой";
        this.inputError = true;
        return false;
      } else {
        this.inputError = false;
        return true;
      }
    },
  },
  destroyed() {
    // this.closeKey();
  },
};
</script>
<style scoped>
.fd-wrapper {
  display: flex;
  flex-direction: column;
  width: 1140px;
  max-width: 1140px;
  padding-bottom: 20px;
  height: auto;
  position: relative;
}

.fd-audiosFullWrapper {
  display: flex;
  width: 241px;
  position: fixed;
  height: 162px;
  background-color: #fafafa;
  bottom: 48px;
  left: 76px;
  width: 100%;
  padding: 0px 16px;
  align-items: center;
}

.fd-allAudiosPlayWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.fd-allPlayButton {
  background-color: #eff0fd !important;
  border-radius: 50px;
  box-shadow: none;
  outline: none;
  height: 38px !important;
  width: 38px !important;
  margin-bottom: 10px;
}

.fd-newSynthesizeButton {
  display: flex;
  flex-direction: column;
  width: 119px;
  height: 110px;
  border: 2px dashed #e5e5e5;
  border-radius: 7px;
  margin: 0 16px;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #98a7ad;
  justify-content: center;
  transition: all 0.3s;
}

.fd-newSynthesizeButton:hover {
  background-color: #e5e5e5;
  border: none;
  transition: all 0.3s;
}

.fd-audiosWrapper {
  display: flex;
  width: calc(100% - 265px);
  overflow-x: scroll;
  height: 162px;
}

.fd-audiosWrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  height: 8px;
}

.fd-audiosWrapper::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.fd-headWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.fd-titleWrapper {
  display: flex;
  align-items: center;
  margin: 0 10px 10px 0;
}

.fd-folderTitle {
  display: inline;
  font-size: 14px;
  font-weight: 700;
  color: #767676;
  margin: 0 5px;
}

.fd-folderName {
  height: auto;
  font-size: 20px;
  font-weight: 700;
  color: #231f20;
}

.fd-button {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none !important;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  transition: all 0.5s;
}

.fd-button:hover {
  background-color: #f5f5f5;
  transition: all 0.5s;
}

.fd-createAudiosButton {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-bottom: 10px;
  height: 40px !important;
  width: 200px;
  letter-spacing: 0;
  text-indent: 0;
}

.fd-synthesizeButton {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
}

.fd-subTitle {
  font-size: 14px;
  font-weight: 700;
  color: #767676;
}

.fd-synthesizeWrapper {
  display: flex;
}

.fd-inputWrapper {
  width: 60%;
}

.fd-textShowWrapper {
  margin-top: 56px;
  width: 60%;
  padding: 16px;
  height: 352px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  overflow-y: scroll;
}

.fd-textShowWrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
}

.fd-textShowWrapper::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.fd-settingsWrapper {
  width: calc(40% - 40px);
  margin-left: 40px;
}

.fd-settingsTitleWrapper {
  display: flex;
  justify-content: space-between;
  height: 46px;
  align-items: flex-end;
  margin-bottom: 10px;
}

.fd-settingsTitle,
.fd-videoIns {
  display: flex;
  color: #98a7ad;
  font-size: 14px;
  font-weight: 500;
  height: 18px;
  align-items: center;
}

.fd-videoIns {
  font-weight: 400;
  height: 16px;
  cursor: pointer;
}

.fd-videoIns:hover {
  text-decoration: underline;
}

.fd-toolsWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 352px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  justify-content: space-between;
}

.fd-checkBoxTitle,
.fd-soundSpeed {
  font-weight: 500;
  font-size: 14px;
  color: #231f20;
  margin-bottom: 8px;
}

.fd-soundSpeed {
  margin-top: 16px;
}

.fd-speedSelectWrapper {
  width: 242px;
}

.v-input:focus {
  outline: none !important;
  color: #777ff6 !important;
}

.fd-checkboxesWrapper {
  display: flex;
  flex-direction: column;
}

.fd-checkboxWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.fd-audioTitleStyle {
  font-size: 14px;
  font-weight: 500;
  color: #231f20;
  line-height: 16px;
}

.fd-audioInfoStyle {
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  line-height: 24px;
}

.fd-playButton {
  display: flex;
  height: 16px;
  margin-left: 10px;
  cursor: pointer;
}

.fd-disableSlider {
  bottom: 0;
  position: absolute;
  height: 2px;
  width: 100%;
  background-color: #e5e5e5;
}

.v-tab {
  color: #98a7ad !important;
  font-size: 14px;
  font-weight: 700;
  text-transform: initial;
  letter-spacing: 0;
}

.v-tab--active {
  color: #777ff6 !important;
}

.v-input {
  margin: 0;
}

.v-radio {
  margin: 0 !important;
}

.v-label {
  font-size: 14px !important;
  color: #000000 !important;
}

.fd-textInput {
  width: 100%;
  resize: none;
  padding: 16px;
  height: 352px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
}

.fd-textInput:focus {
  outline: none;
  border: 1px solid #767676;
}

.fd-textInput:hover {
  border: 1px solid #767676;
}

.fd-synthesizeHeader {
  display: flex;
  justify-content: center;
}

.fd-characterCountWrapper {
  display: flex;
  position: absolute;
  font-size: 14px;
  color: #767676;
  bottom: 16px;
  right: 16px;
}

.fd-characterWarning {
  color: red;
}

.fd-fileInputWrapper {
  width: 100%;
  height: 352px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 16px;
}

.fd-fileInput {
  width: 300px;
}

.fd-fileInputInfo {
  font-size: 14px;
  color: #767676;
  margin: 8px 0px 30px 0;
}

.fd-fileInputIns {
  font-size: 14px;
  color: #767676;
  font-weight: 700;
  margin-bottom: 20px;
}

.fd-tableWrapper {
  width: 100%;
  margin-top: 40px;
}

.fd-tableTitle {
  font-size: 14px;
  line-height: 16px;
  font-weight: 700;
  color: #767676;
  margin-bottom: 10px;
}

.fd-tableHeader {
  display: flex;
  max-width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  text-align: left;
  margin-bottom: 4px;
}

.fd-fileName {
  width: 25%;
  min-width: 200px;
  margin-right: 30px;
}

.fd-status {
  min-width: 66px;
  margin-right: 30px;
}

.fd-duration {
  min-width: 88px;
  margin-right: 30px;
}

.fd-createdDate {
  min-width: 140px;
  margin-right: 30px;
}

/* Диалог хэлбэржүүлэлтүүд */
.fd-dialogWrapper {
  padding: 31px 38px;
}

.fd-videoDialogWrapper {
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
}

.fd-dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.fd-dialogTitle {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-left: 5px;
}

.fd-dialogWarn {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  margin-bottom: 10px;
}

.fd-inputDialogWrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 56px;
}

.fd-inputDialogWrapper input[type="text"] {
  height: 40px !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.fd-inputDialogWrapper input[type="text"]:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.fd-inputDialogWrapper input[type="text"]:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.fd-errorInput {
  font-size: 12px;
  line-height: 14px;
  color: red;
  margin: 2px 0 0 10px;
}

.fd-dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.fd-closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}

.fd-changeBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.fd-dialogRemoveTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  color: #d23636;
}

.fd-dialogRemoveTitle {
  font-size: 16px;
  font-weight: 500;
  color: #d23636;
  margin-left: 10px;
  line-height: 18px;
}

.fd-dialogRemoveQuestion {
  font-size: 14px;
  line-height: 16px;
  color: #767676;
}

.fd-removeBtn {
  background-color: #d23636 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.fd-loadingLinear {
  display: flex;
  align-items: top;
  width: 100%;
  justify-content: flex-start;
  margin-top: 40px;
}

.fd-infoLoadingWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 560px;
}

@media screen and (max-width: 930px) {
  .fd-synthesizeWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .fd-inputWrapper {
    width: 100%;
  }

  .fd-settingsWrapper {
    width: 100%;
    margin: 0;
  }

  .fd-toolsWrapper {
    height: auto;
  }
}

@media screen and (max-width: 900px) {
  .fd-fileName {
    width: 70%;
  }

  .fd-createdDate,
  .fd-status,
  .fd-duration {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .fd-dialogWrapper {
    padding: 20px;
  }
}

@media screen and (max-width: 599px) {
  .fd-headWrapper {
    justify-content: center;
  }

  .fd-subTitle {
    display: flex;
    justify-content: center;
  }

  .fd-fileInput {
    width: 250px;
  }
}
</style>
